import { selectUserInfo } from "features/user/userSlice";
import VerticalTabs from "common/ComponentSidebar/ComponentSideBar";
import { checkPrivileges } from "Helpers/CheckPrivileges";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

interface tabProps {
  params: any;
  selectedIndex: number;
}
export default function ClientTabs(props: tabProps) {
  const navigate = useNavigate();
  const loggedInUserData = useSelector(selectUserInfo);
  const isOwner = loggedInUserData?.type === -1;
  const clientBase = `/client/${props.params?.id}/account/${props.params?.accountId}`;
  const preference = `invoicingPreference/${props.params?.invoicingPreference}`;
  const handleChangeTabs = (tabId: number) => {
    if (tabId === 0) navigate(`${clientBase}/${preference}`);
    else if (tabId === 1)
      navigate(`${clientBase}/update-password/${preference}`);
    else if (tabId === 2) navigate(`${clientBase}/drivers/${preference}`);
    else if (tabId === 3) navigate(`${clientBase}/vehicles/${preference}`);
    else if (tabId === 4) navigate(`${clientBase}/invoices/${preference}`);
    else if (tabId === 5)
      navigate(`${clientBase}/delivery-notes/${preference}`);
    else if (tabId === 6) navigate(`${clientBase}/payments/${preference}`);
    else if (tabId === 7) navigate(`${clientBase}/reviews/${preference}`);
    else if (tabId === 8 && isOwner)
      navigate(`${clientBase}/integrations/${preference}`);
  };
  const tabs = [
    { id: 0, title: `edit`, child: <></> },
    { id: 1, title: `updatePassword`, child: <></> },
    { id: 2, title: `drivers`, child: <></> },
    { id: 3, title: `vehicles`, child: <></> },
    { id: 4, title: `invoices`, child: <></> },
    { id: 5, title: `deliveryNotes`, child: <></> },
    { id: 6, title: `payments`, child: <></> },
    { id: 7, title: `reviews`, child: <></> },
    ...(isOwner ? [{ id: 8, title: `integrations`, child: <></> }] : []),
  ];
  const disableTabs = tabs
    .map((tab) => tab.id)
    .filter((tabId) => {
      switch (tabId) {
        case 0:
          return !checkPrivileges("ROLE_CLIENT_UPDATE");
        case 1:
          return !checkPrivileges("ROLE_CHANGE_PASSWORD");
        case 2:
          return !checkPrivileges("ROLE_CLIENT_UPDATE");
        case 3:
          return !checkPrivileges("ROLE_VEHICLE_VIEW");
        case 4:
          return !checkPrivileges("ROLE_INVOICE_VIEW");
        case 5:
          return !checkPrivileges("ROLE_DELIVERY_NOTE_VIEW");
        case 6:
          return !checkPrivileges("ROLE_PAYMENT_VIEW");
        case 7:
          return false;
        case 8:
          return !isOwner;
        default:
          return false;
      }
    });
  return (
    <>
      <VerticalTabs
        tabs={tabs}
        selectedIndex={props.selectedIndex}
        handleChangeTabs={handleChangeTabs}
        disableTabNo={disableTabs}
      />
    </>
  );
}
